import style from '@root-gipro/modules/AdminPanel/components/AdminObjectsAnalog/components/modals/AdminAddObjectAnalog/AdminAddObjectAnalog.module.scss';

import { Fade, Modal, Theme, createStyles, makeStyles, TextField } from '@material-ui/core'
import React, { ChangeEvent, FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IState } from '@root-gipro/store/interfaces'
import {
  createAdminOA,
  setAdminAddModalOA
} from '@root-gipro/modules/AdminPanel/store/actions/actionAdminObjectsAnalog'
import {
  TAddAdminOAModalErrorData
} from '@root-gipro/modules/AdminPanel/interfaces/adminObjectsAnalog'
import Loader from '@root-gipro/shared/Loader/Loader'

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			overflow: 'auto',
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
		},
    helperText: {
      marginLeft: 0
    },
	})
)

const AdminAddObjectAnalog: FC = () => {
  
	const classes = useStyles();
	const dispatch = useDispatch();
  const companyId = localStorage.getItem('companyId');

  const {
    objectsAnalogCommon
  } = useSelector((state: IState) => state.adminPanel);
  
  const requiredMessage = 'Поле обязательно для заполнения';
	const [errorData, setErrorData] = useState<TAddAdminOAModalErrorData>({
		name: { error: false, message: requiredMessage },
		th_name: { error: false, message: requiredMessage },
		th_count: { error: false, message: requiredMessage },
		th_unit: { error: false, message: requiredMessage },
		file: { error: false, message: requiredMessage },
	});
  const [isAddBtnDisabled, setIsAddBtnDisabled] = useState(true);
  const [selectedFile, setSelectedFile] = useState<File|null>(null);
  const [selectedFileName, setSelectedFileName] = useState<string|null>(null);
  
  const onCloseHandler = () => {
    dispatch(setAdminAddModalOA(null));
  };
  
  const onInputChangeHandler = (
    e: ChangeEvent<HTMLInputElement|HTMLTextAreaElement>, 
    name: string
  ) => {

    const files = (e.target as HTMLInputElement).files;
    const value = e.target?.value ?? '';

    dispatch(setAdminAddModalOA({
      inputs: { [name]: e.target.value }
    }));
    
    if(name === 'fileName') {
      if(files?.length) {
        setSelectedFile(files[0]);
        setSelectedFileName(files[0].name);
      }
    }
    
    setErrorData(prev => ({
      ...prev,
      [name]: { 
        ...prev[name as keyof TAddAdminOAModalErrorData], 
        error: !value.length 
      }
    }));
  };
  
  const onAddHandler = () => {
    if(objectsAnalogCommon.addOAModal?.inputs && companyId) {
      dispatch(createAdminOA({
        company_id: companyId,
        file: selectedFile,
        inputs: {
          ...objectsAnalogCommon.addOAModal.inputs,
        }
      }));
    }
  };

  useEffect(() => {
    
    let isError = false;
    
    if(objectsAnalogCommon.addOAModal?.inputs) {
      for(const key in objectsAnalogCommon.addOAModal.inputs) {
        
        // @ts-ignore
        if(!objectsAnalogCommon.addOAModal.inputs[ key ].length) {
          setIsAddBtnDisabled(true);
          isError = true;
        }
        
        if(!isError) setIsAddBtnDisabled(false);
      }
    }
  }, [objectsAnalogCommon.addOAModal?.inputs])

  return (
		<Modal
			open={objectsAnalogCommon.addOAModal?.isOpen ?? false}
			onClose={onCloseHandler}
			aria-labelledby='simple-modal-title'
			aria-describedby='simple-modal-description'
			className={classes.modal}
			closeAfterTransition
		>
			<Fade in={objectsAnalogCommon.addOAModal?.isOpen}>
				<form
          className={style.adminAddObjectAnalog}
					noValidate
					autoComplete='off'
					style={{ background: 'white', padding: '32px', maxWidth: 550, width: '100%' }}
				>
					<div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: 16 }}>

            <h3>Объект-аналог</h3>
            
            <div>
              <TextField
                value={objectsAnalogCommon.addOAModal.inputs?.name}
                placeholder='Наименование объекта-аналога'
                variant='outlined'
                onChange={(e) => onInputChangeHandler(e, 'name')}
                error={errorData.name.error}
                FormHelperTextProps={{
                  className: classes.helperText,
                }}
                
                {...(errorData.name.error && { helperText: errorData.name.message })}
              />
            </div>

            <div>
              <TextField
                value={objectsAnalogCommon.addOAModal.inputs?.th_name}
                placeholder='Название ТХ'
                variant='outlined'
                onChange={(e) => onInputChangeHandler(e, 'th_name')}
                error={errorData.th_name.error}
                FormHelperTextProps={{
                  className: classes.helperText,
                }}
                
                {...(errorData.th_name.error && { helperText: errorData.th_name.message })}
              />
            </div>

            <div>
              <TextField
                type='number'
                value={objectsAnalogCommon.addOAModal.inputs?.th_count}
                placeholder='Количество'
                variant='outlined'
                onChange={(e) => onInputChangeHandler(e, 'th_count')}
                error={errorData.th_count.error}
                FormHelperTextProps={{
                  className: classes.helperText,
                }}

                {...(errorData.th_count.error && { helperText: errorData.th_count.message })}
              />
            </div>

            <div>
              <TextField
                value={objectsAnalogCommon.addOAModal.inputs?.th_unit}
                placeholder='Единица измерения'
                variant='outlined'
                onChange={(e) => onInputChangeHandler(e, 'th_unit')}
                error={errorData.th_unit.error}
                FormHelperTextProps={{
                  className: classes.helperText,
                }}

                {...(errorData.th_unit.error && { helperText: errorData.th_unit.message })}
              />
            </div>

            <div>
              <div className={style.adminAddObjectAnalog__fileInputWr}>
                <input
                  className={style.adminAddObjectAnalog__fileInput}
                  type="file"
                  onChange={(e) => onInputChangeHandler(e, 'fileName')}
                />
                
                <div className={style.adminAddObjectAnalog__fileInputPlaceholderWr}>
                  <div className={style.adminAddObjectAnalog__fileInputPlaceholder}>
                    Прикрепить файл
                  </div>

                  {selectedFileName && (
                    <div className={style.adminAddObjectAnalog__fileInputFileName}>
                      {selectedFileName}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={style.adminAddObjectAnalog__btns}>
            <div className={
              style.adminAddObjectAnalog__btnWr +
              (isAddBtnDisabled ? ` ${style.adminAddObjectAnalog__btnWrDisabled}` : '')
            }>
              <button
                className={style.adminAddObjectAnalog__btn}
                onClick={onAddHandler}
                type='button'
              >
                Добавить
                <span
                  className={
                    style.adminAddObjectAnalog__preloaderWr +
                    (objectsAnalogCommon.addOAModal?.isAdding ? ` ${style.adminAddObjectAnalog__preloaderWrShow}` : '')
                  }
                >
                  
								<span className={style.adminAddObjectAnalog__preloader}>
									<Loader />
								</span>
							</span>
              </button>
            </div>
          </div>
				</form>
			</Fade>
		</Modal>
	)
}

export default AdminAddObjectAnalog;
